// src/components/pages/AboutPage.js
// 다른 메뉴(Home/Expertise/Solution/Business)와 동일한 레이아웃으로 통일
// "Abocado 비전"을 클릭하면 about.mp4 가 그 자리에서 재생됩니다.
import React, { useState } from 'react';
import { Box, Typography, Grid, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Leaf } from 'lucide-react';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import HeroBanner from '../common/HeroBanner';
import DescriptionBlock from '../common/DescriptionBlock';
import FeatureCard from '../common/FeatureCard';

// 카드 순서: 에너지 효율성 → 지속가능한 농업 → 기술 혁신 (아이콘 없이 텍스트만)
const VISION_ITEMS = [
  {
    title: '에너지 효율성',
    description: '연료전지와 스마트 기술을 결합하여 에너지 효율을 극대화하고, 탄소 중립 농업을 실현합니다.',
    gradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
  },
  {
    title: '지속가능한 농업',
    description: (
      <>
        친환경 기술을 활용하여 지속가능한 농업 생태계를 구축하고, 미래 세대를 위한
        <br />
        농업 환경을 보전합니다.
      </>
    ),
    gradient: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)'
  },
  {
    title: '기술 혁신',
    description: (
      <>
        AI, IoT, 디지털 트윈 등 첨단 기술을 농업에 적용하여 생산성 향상과
        <br />
        품질 개선을 동시에 달성합니다.
      </>
    ),
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)'
  }
];

const AboutPage = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <Box sx={{ width: '100%' }}>
      {/* 상단 메인 이미지 - 다른 메뉴와 동일한 컴포넌트, 높이만 줄여서 한 화면에 들어오게 처리 */}
      <HeroBanner image="/images/about-hero.png" overlay={false} maxHeight="160px" />

      {/* 검은 배경 설명 블록 - 다른 메뉴와 동일한 톤 */}
      <DescriptionBlock
        title="About Abocado"
        paragraphs={['에너지 효율적인 농업 혁신을 선도하는 기업']}
      />

      {/* 비전 섹션 */}
      <Box sx={{ p: { xs: 3, md: 4 }, backgroundColor: '#0f172a', textAlign: 'center' }}>
        <Box
          component="button"
          onClick={() => setShowVideo(true)}
          sx={{
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 2,
            p: 0,
            '&:hover': { opacity: 0.85 }
          }}
        >
          <Leaf size={64} color="#22c55e" style={{ marginBottom: 8 }} />
          <Typography
            variant="h5"
            sx={{ color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
          >
            Abocado 비전
            <PlayCircleOutlineIcon fontSize="medium" />
          </Typography>
        </Box>

        <Dialog
          open={showVideo}
          onClose={() => setShowVideo(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { backgroundColor: '#000', position: 'relative' } }}
        >
          <IconButton
            onClick={() => setShowVideo(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'white',
              zIndex: 1,
              backgroundColor: 'rgba(0,0,0,0.4)',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' }
            }}
          >
            <CloseIcon />
          </IconButton>
          {showVideo && (
            <video
              controls
              autoPlay
              style={{ width: '100%', display: 'block' }}
              src="/images/about.mp4"
            >
              브라우저가 비디오 태그를 지원하지 않습니다.
            </video>
          )}
        </Dialog>

        <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
          {VISION_ITEMS.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <FeatureCard
                gradient={item.gradient}
                title={item.title}
                description={item.description}
                height="120px"
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default AboutPage;
